import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
     <div className="container">
          <ul className='link-area'>
        <li>
            <Link to="/" type="" href="">Home</Link>
          </li>
       
          <li>
            <Link to="/terms" type="" href="">Terms</Link>
          </li>
          <li>
            <Link to="/privacy-policy" type="" href="">Privacy</Link>
          </li>
          <li>
            <Link to="/cookies" type="" href="">Cookies</Link>
          </li>
             <li>
            <Link to="/news&articles" type="" href="">News & Articles</Link>
          </li>
        </ul>
        <div className="social-area">
          <div className="logo">
          <Link to="/"><img src="/images/logo-footer.svg" alt="" /></Link>
          </div>
          <ul className='flex'>
            <li>
              <Link to="https://www.instagram.com/rzto.io"><img src="/images/social-insta.svg" alt="" /></Link>
            </li>
            <li>
              <Link to="https://medium.com/@rzto.io"><img src="/images/social-m.svg" alt="" /></Link>
            </li>
            <li>
              <Link to="https://t.me/rztoio"><img src="/images/social-teligram.svg" alt="" /></Link>
            </li>
            <li>
              <Link to="https://x.com/RZTOIO"><img src="/images/social-x.svg" alt="" /></Link>
            </li>
            <li>
              <Link to="https://coinmarketcap.com/community/profile/RZTO"><img src="/images/social-ms.svg" alt="" /></Link>
            </li>
          </ul>
        </div>    
        <p className="copyright">© {new Date().getFullYear()} Rizz Network Inc.</p>
      </div>
    </footer>
  );
}
